import {INITIALIZE_STATIC_CONFIG, SET_CONFIG, STATIC_CONFIG_INITIALIZED} from "@/core/store/modules/config/constants";

export default {
    [INITIALIZE_STATIC_CONFIG](context) {
        return new Promise((resolve, reject) => {
            fetch('/config.json?t=' + Date.now()).then((serverPromise) => serverPromise.json().then((response) => {
                context.commit(SET_CONFIG, response);
                resolve(response)
                context.dispatch(STATIC_CONFIG_INITIALIZED)
            })).catch((error) => {
                reject(error)
            })
        })

    }
}